import { FC } from "react";
import Card from "react-bootstrap/Card";
import { FaInfoCircle } from "react-icons/fa";

export const AllReportRolePermissionsOverviewCard: FC = () => (
    <Card>
        <Card.Body>
            <Card.Title className="mb-3">
                <FaInfoCircle /> Roles
            </Card.Title>
            <Card.Subtitle>Standard</Card.Subtitle>
            <ul>
                <li>Can view the full report, dashboard, etc.</li>
            </ul>
            <Card.Subtitle>Limited</Card.Subtitle>
            <ul>
                <li>Can view only the test certificate for the report</li>
            </ul>
        </Card.Body>
    </Card>
);
